import cx from 'classnames';

type ToggleProps = {
  label: string;
  className?: string;
  helperText?: string;
  defaultValue?: boolean;
  value?: boolean;
  disabled?: boolean;
  onChange: (value: boolean) => void;
  size?: 'small' | 'medium';
};

export function Toggle({
  label,
  className,
  helperText,
  defaultValue = false,
  value,
  disabled = false,
  onChange,
  size = 'medium',
}: ToggleProps) {
  return (
    <div className={cx("form-field", className, disabled && 'opacity-50')}>
      <label className="toggle-container flex items-center">
        <input
          type="checkbox"
          className={cx(
            'toggle-input',
            size === 'small' ? 'w-6 h-4' : 'w-8 h-5',
          )}
          checked={value ?? defaultValue}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
        />
        <span className="toggle-label">{label}</span>
      </label>
      
      {helperText && <p className="helper-text">{helperText}</p>}
    </div>
  );
} 